export default "__VITE_ASSET__CYuPSJ6I__"